module.exports = __webpack_public_path__ + "img/hackazon-planet.ac83c1ff.png";